import React from 'react';

import useBuilderConstructorGridInputs from '../hooks/useBuilderConstructorGridInputs';

const MobileGridStickySideNavHeader = () => {
  const { sideNav } = useBuilderConstructorGridInputs();
  const showStickySideNavHeader = sideNav?.shouldShowCategoryNav;

  if (!showStickySideNavHeader) {
    return null;
  }

  return (
    <div className="mt-[16px] mb-[24px]">
      <button type="button" className="w-full font-bold text-[20px]">
        Mobile Sticky Side Nav Header
      </button>
    </div>
  );
};

export default MobileGridStickySideNavHeader;
